export default __webpack_public_path__ + "static/media/savannah-crystal.999d3eeb.png";